import { context, productUtils } from '@tools/wr-catalog-base'

const CATEGORY_GROUPS = {
  segment: 'segments_dropdown',
  product: 'product_dropdown',
  serviceType: 'service_type_dropdown',
  serviceCategory: 'service_category_dropdown',
}

const matchProductCategories = (product, groupedFilters) => {
  // Hybrid AND/OR filtering
  // (seg1 OR seg2 OR ...) AND (serType1 OR serType2 OR ...) AND (prod1 OR prod2 OR ...)
  return Object.keys(CATEGORY_GROUPS).every((type) => {
    // If no selections in group then just ignore
    if (!groupedFilters[type].length) return true

    return groupedFilters[type].some((catId) => {
      return product.categories.find((cat) => cat.id === catId)
    })
  })
}

const groupCategoryFilters = (categoryFilters, categories) => {
  return Object.entries(CATEGORY_GROUPS).reduce((memo, [type, tag]) => {
    const catsForType = categories.filter((item) => item.parentTags && item.parentTags.includes(tag))
    memo[type] = categoryFilters.filter((id) => catsForType.find((cat) => cat.id === id))
    return memo
  }, {})
}

// Copied and modified from wr-catalog-base/src/modules/product/product-utils.js
export const filterProducts = (catalogs, searchFilter, searchableKeys, productsToDisplay = [], priceFilter) => {
  const { categoryFilters } = context.state
  const { categories } = context.state

  const groupedFilters = categoryFilters.length ? groupCategoryFilters(categoryFilters, categories) : null

  const updatedProducts = []
  const searchPattern = productUtils.createProductFilter(searchFilter)

  catalogs.forEach((catalog) => {
    let products = Array.isArray(catalog) ? catalog : catalog && catalog.contents ? catalog.contents.items : null

    if (!products) return

    if (productsToDisplay.length > 0) {
      products = products.filter((product) => productsToDisplay.includes(product.id))
    }

    if (searchFilter) {
      products = products.filter((v) => searchPattern.test(searchableKeys.map((k) => v[k]).join('')))
    }

    if (priceFilter && context.state.priceFilter.maxValue) {
      products = products.filter((product) => {
        const priceValue = parseInt(product.pricing.value)
        return priceValue >= context.state.priceFilter.values[0] && priceValue <= context.state.priceFilter.values[1]
      })
    }

    if (groupedFilters) {
      products = products.filter((product) => matchProductCategories(product, groupedFilters))
    }

    categories.forEach((category) => {
      const productToAdd = products.filter((product) => {
        if (category.id === 'category-undefined' && product.categories.length === 0) {
          return true
        }
        return product.categories.find((cat) => category.id === cat.id)
      })
      const categoryDefined = updatedProducts.find((cat) => cat[category.id])

      if (productToAdd.length) {
        if (categoryDefined) {
          updatedProducts.forEach((cat) => {
            if (cat[category.id]) {
              const prod = Array.isArray(productToAdd) ? productToAdd : [productToAdd]
              cat[category.id].push(...prod)
            }
          })
        } else {
          updatedProducts.push({
            [category.id]: productToAdd,
          })
        }
      }
    })

    if (categories.length === 0) {
      updatedProducts.push({
        'category-undefined': products,
      })
    }
  })

  return {
    products: updatedProducts,
    categories,
  }
}

export const isNullOrEmptyString = (val) => {
  return val === null || val === ''
}
